<template>
  <!-- 回款统计 -->
  <div>
    <div class="home-pannel">
      <div class="home-pannel-title">
        <span>回款统计</span>
        <div>
          <time-query @select="timeSelect"/>
        </div>
      </div>
      <div class="home-pannel-content">
        <a-row  v-if="countPosition === 'top'" style="margin-top:10px;">
          <a-row>
            <a-col class="right-content">
              <a-col v-for="(item,index) in jbkbList" :key="index">
                <a-col v-for="(el, ind) in item" :key="ind" :span="8" style="text-align:center;">
                  <span v-if="el.slot" class="jineValue">{{setJine(jbkbDataObj[el.value])}}</span>
                  <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
                <br>
                  <span>
                    {{el.name}}
                    <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
                  </span>
                </a-col>
              </a-col>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
            <myLineEcharts ref="returnMoneyEchartsRef" echarts-id-val="returnMoneyEcharts" line-title-name="回款金额统计" :echartsHeight="echartsHeight"/>
          </a-col>
          </a-row>
        </a-row>
        <a-row v-else-if="countPosition === 'right'">
          <a-col :span="18">
            <myLineEcharts ref="returnMoneyEchartsRef" echarts-id-val="returnMoneyEcharts" line-title-name="回款金额统计" :echartsHeight="echartsHeight"/>
          </a-col>
          <a-col :span="6" class="right-content">
            <a-row v-for="(item,index) in jbkbList" :key="index" type="flex" justify="space-around">
              <a-col v-for="(el, ind) in item" :key="ind" :span="18" style="margin-top: 40px;text-align:center;">
                <span v-if="el.slot" class="jineValue">{{setJine(jbkbDataObj[el.value])}}</span>
                <span v-else class="jineValue">{{jbkbDataObj[el.value]}}</span>
              <br>
                <span>
                  {{el.name}}
                  <span v-if="el.slot">({{setUnit(jbkbDataObj[el.value])}})</span>
                </span>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import timeQuery from './queryView.vue'
import myLineEcharts from './myLine.vue'
import { setJine, setUnit } from '@/utils/index.js'
export default {
  components: {myLineEcharts, timeQuery},
  props: {
    countPosition: {
      type: String,
      default: 'right'
    },
    echartsHeight: {
      type: String,
      default: '350px'
    }
  },
  data () {
    return {
      jbkbDataObj: {},
      jbkbList: [
        [
          {
            name: '回款客户数(个)',
            value: 'customerCount'
          }
        ],
        [
          {
            name: '回款单数(个)',
            value: 'count'
          }
        ],
        [

          {
            name: '回款金额',
            value: 'moneyCount',
            slot: 'jine'
          }
        ]
      ]
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    setJine,
    setUnit,
    timeSelect (timeVal) {
      this.getData(timeVal)
    },
    getData (timeVal) {
      this.$get('/payBack/mobileBackCount', {timeCondition: timeVal, backType: 1}).then(res => {
        if (res.data.status === 1) {
          this.jbkbDataObj = res.data.data
          this.$nextTick(() => {
            this.$refs.returnMoneyEchartsRef.setData(this.jbkbDataObj.mobileBackCountTableVos)
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.right-content{
}
  .jineValue{
    color:#4b9de1;
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/returnMoneyInfo.vue